import { useTranslation } from 'react-i18next';

import { SmartShell } from '../../components/smart/SmartShell';
import { WizardComposePanel } from '../../components/smart/WizardComposePanel';

export const WizardRoutePage = () => {
  const { t } = useTranslation('smart');
  return (
    <SmartShell
      title={t('wizard.headline.compose.title')}
      subtitle={t('wizard.headline.compose.subtitle')}
    >
      <WizardComposePanel focusStep="route" />
    </SmartShell>
  );
};
